import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PartnerRegister from './PartnerRegister';
import PartnerDashboard from './PartnerDashboard';

export function PartnerApp() {
  return (
    <Routes>
      <Route path="register" element={<PartnerRegister />} />
      <Route path="" element={<PartnerDashboard />} />
      <Route path="*" element={<Navigate to="/partner" replace />} />
    </Routes>
  );
}

export default PartnerApp;
